// **React Imports
import React, { memo, useCallback, useEffect, useState } from 'react'

// **MUI Imports
import { Box, Tooltip, Typography } from '@mui/material'

// **Component Imports
import Icon from '../../../../../components/icon'
import CustomDialog from '../../../../../components/dialog'
import { TOOLTIPS } from '../../../../../utils/tooltips'

const VideoItem = memo(({ recording, isActive, setSelectedRecording }) => {
  return (
    <Box
      className={`video-list-item-container ${isActive ? 'active' : ''}`}
      onClick={() => setSelectedRecording()}
    >
      <Icon
        icon={
          recording?.fileName?.startsWith('screen')
            ? 'lucide:screen-share'
            : recording?.fileName?.startsWith('webcam')
            ? 'gravity-ui:video'
            : 'octicon:video-16'
        }
        fontSize={'2rem'}
      />
      <Typography>{recording?.fileName}</Typography>
    </Box>
  )
})

const PlayRecording = ({ className, recordings }) => {
  // State
  const [open, setOpen] = useState(false)
  const [selectedRecording, setSelectedRecording] = useState(0)

  // Handlers

  const handleModalOpen = useCallback(() => {
    setOpen(true)
  }, [])

  const handleModalClose = useCallback(() => {
    setOpen(false)
  }, [])

  const updateZIndex = useCallback((reduceIndex = false) => {
    const ele = document.querySelector('.webcam-sharing-window')
    const ele1 = document.querySelector('.screen-sharing-window')
    if (reduceIndex) {
      if (ele) {
        ele.style.zIndex = 1200
      }
      if (ele1) {
        ele1.style.zIndex = 1200
      }
    } else {
      if (ele) {
        ele.style.zIndex = 2000
      }
      if (ele1) {
        ele1.style.zIndex = 2000
      }
    }
  }, [])

  //useEffect
  useEffect(() => {
    if (!open) {
      setSelectedRecording(0)
      updateZIndex()
    } else {
      updateZIndex(true)
    }
  }, [open, updateZIndex])

  return (
    <>
      <Tooltip title={TOOLTIPS.evaluateCandidateRecording}>
        <Box
          mt={2}
          onClick={handleModalOpen}
          className={className || `sidepanel-challenge-item`}
        >
          <Icon icon={'carbon:play-filled'} fontSize={'2rem'} />
          <Typography fontSize={'9px'} sx={{ textAlign: 'center' }}>
            Evaluate Recordings
          </Typography>
        </Box>
      </Tooltip>
      <CustomDialog
        open={open}
        outsideClikClose={false}
        title={'Evaluate Recordings'}
        handleClose={handleModalClose}
        dialogPaperStyle={{
          width: '95%',
          height: '95%',
          maxWidth: '1500px',
          '& .MuiDialogContent-root': {
            padding: '0px !important'
          }
        }}
      >
        {open && (
          <Box className="evaluate-recording-modal-container">
            <Box className="video-list-container">
              {recordings?.map((recording, recordingIndex) => (
                <VideoItem
                  key={recording?.url}
                  recording={recording}
                  isActive={recordingIndex === selectedRecording}
                  setSelectedRecording={() =>
                    setSelectedRecording(recordingIndex)
                  }
                />
              ))}
            </Box>
            <Box className="video-player-container">
              {selectedRecording !== null &&
                recordings?.[selectedRecording]?.url && (
                  <video
                    controls
                    autoPlay
                    disablePictureInPicture={true}
                    src={recordings?.[selectedRecording]?.url}
                  />
                )}
            </Box>
          </Box>
        )}
      </CustomDialog>
    </>
  )
}

export default PlayRecording
